import type {SlotGameStore, BaseComponentConfig, Spine} from "@gamzix/slot_core";

import {CircleReel} from "./circleReel";

class BonusReelsetComponent extends Game.src.component.BaseComponent {
    protected waitClick: () => Promise<void>;

    public isBonusGameStart: boolean = false;

    public reels = [];
    public multArray = [];
    public arrayZeroAlpha = [];

    public backgroundBonus;
    public spine_gm;
    public shine_gm_reel0;
    public shine_gm_reel1;
    public shine_gm_reel2;
    public textClickAnywhere;
    public popup;
    public popup2;
    public xSymbol;
    public popupOutroContainer;
    public clickAnywhereOutroPopup;
    public winOutroText;

    protected additionalTime: number = 0;

    constructor(config: BaseComponentConfig) {
        super(config);

        this.text_checkers = {
            ...super.getTextCheckers(),
            TOTAL_X: () => {
                const bet: string = game.localization.get('game_rules.table.button_switch_bet.name_value');
                // @ts-ignore
                const multiplier: number =  game.store.gameData.bonusGame.multiplier()?.multiplier;
                return `x${multiplier} ${bet}`
            },
        }

        this.status_checkers = {
            ...super.getStatusCheckers(),

            isBonusGameStart: () => this.isBonusGameStart
        };
    }

    onGameReady() {
        super.onGameReady();

        this.createSpineAndSearchItems();
        this.createReels();

        game.once('SET_WAIT_CLICK', ({waitClick}) => this.waitClick = waitClick);
        game.on(Game.events.ON_REQUEST_ANIMATION_FRAME, this.onUpdate.bind(this));
    }

    createSpineAndSearchItems(){
        this.popup = game.tree.findByName('number_reel_set.wrapper_container');
        this.popup2 = game.tree.findByName('bonus_game.number_reel_set.main.wrapper_container');
        this.textClickAnywhere = game.tree.findByName('bonus_game.click_anywhere_start');
        this.xSymbol = game.tree.findByName('gm_bonus_x_symbol');
        this.backgroundBonus = game.tree.findByName('background_bonus');

        this.popupOutroContainer = game.tree.findByName("bonus_game.wrapper_container.popup_outro_container");
        this.clickAnywhereOutroPopup = game.tree.findByName("bonus_game.wrapper_container.popup_outro_container.click_anywhere");
        this.winOutroText = game.tree.findByName("bonus_game.wrapper_container.popup_outro_container.bonus_outro_value");

        this.createSpine();

        game.utils.GameUtils.playScaleYoyoAnimation(this.textClickAnywhere, {scaleFrom: 1, scaleTo: 1.1, time: 1000, loop: -1});
    }

    protected createSpine(){
        this.spine_gm = <Spine>game.builder.create(this.options.config.bonusReelsetSpineGMConfig);
        this.popup.addChild(this.spine_gm);

        for (let i = 0; i < 3; i++) {
            this[`shine_gm_reel${i}`] = <Spine>game.builder.create(this.options.config[`bonusReelsetSpineShineConfig_reel_${i}`]);
            this.popup.addChild(this[`shine_gm_reel${i}`]);
        }
    }

    protected createReels(){
        for (let i = 0; i < 3; i++) {
            let reel: CircleReel = new CircleReel();
            reel.index = i;
            reel.init();
            this.reels.push(reel);
        }
    }

    onUpdate({deltaTime}): void {
        this.reels.forEach(reel => reel.onUpdate(deltaTime));
    }

    async initShowPopup() {
        for (const item of this.reels) {
            for (const symbol of item.symbols) {
                symbol.id = '20';
                symbol.playStatic();
            }
        }

        //@ts-ignore
        this.multArray = game.store.gameData.bonusGame.multiplier().multiplier.toString().padStart(3, '0').split('').map(Number);

        this.popup2.alpha = 0;
        this.popup2.visible = true;

        await game.utils.delay(300);
        game.utils.GameUtils.playAlphaAnimation(this.backgroundBonus, {from: 0, to: 1, time: 300, timeWait: 0});
        await game.utils.GameUtils.playAlphaAnimation(this.popup2, {from: 0, to: 1, time: 300, timeWait: 0});

        this.textClickAnywhere.options.visible = true;

        await Promise.race([
            this.waitClick(),
            game.onceDataPromise('Button.clicked', {
                name: 'bonus.wrapper_container.btn'
            })
        ])

        game.tree.findByName('bonus.wrapper_container.btn').visible = false

        this.textClickAnywhere.options.visible = false;
    }

    startRotateReels() {
        this.spine_gm.playAnimation('GM', false);

        game.emit('BonusGameComponent.REELSET_SPIN');

        this.shine_gm_reel0.visible = true;
        this.shine_gm_reel1.visible = true;
        this.shine_gm_reel2.visible = true;

        this.reels.forEach(item => item.startRotate());
    }

    idPlus(arr) {
        return (arr + 1 === 20) ? arr + 1 - 10 : arr + 1;
    }

    idMinus(arr) {
        return (arr - 1 === 9) ? arr - 1 + 10 : arr - 1;
    }

    fakeListMap(){
        let winArray = [this.idMinus(10 + this.multArray[0]), 10 + this.multArray[0], this.idPlus(10 + this.multArray[0])];

        const fakeListMap = new Map<string, string[]>([
            [JSON.stringify([19, 10, 11]), ['18', '17', '16', '15', '14', '13', '12', '11', '10', '19', '18', '17', '16']],
            [JSON.stringify([10, 11, 12]), ['19', '18', '17', '16', '15', '14', '13', '12', '11', '10', '19', '18', '17']],
            [JSON.stringify([11, 12, 13]), ['10', '19', '18', '17', '16', '15', '14', '13', '12', '11', '10', '19', '18']],
            [JSON.stringify([12, 13, 14]), ['11', '10', '19', '18', '17', '16', '15', '14', '13', '12', '11', '10', '19']],
            [JSON.stringify([13, 14, 15]), ['12', '11', '10', '19', '18', '17', '16', '15', '14', '13', '12', '11', '10']],
            [JSON.stringify([14, 15, 16]), ['13', '12', '11', '10', '19', '18', '17', '16', '15', '14', '13', '12', '11']],
            [JSON.stringify([15, 16, 17]), ['14', '13', '12', '11', '10', '19', '18', '17', '16', '15', '14', '13', '12']],
            [JSON.stringify([16, 17, 18]), ['15', '14', '13', '12', '11', '10', '19', '18', '17', '16', '15', '14', '13']],
            [JSON.stringify([17, 18, 19]), ['16', '15', '14', '13', '12', '11', '10', '19', '18', '17', '16', '15', '14']],
            [JSON.stringify([18, 19, 10]), ['17', '16', '15', '14', '13', '12', '11', '10', '19', '18', '17', '16', '15']]
        ]);

        return  fakeListMap.get(JSON.stringify(winArray));
    }

    async customStopRotateReels() {
        this.additionalTime = 0;
        const reelConfigs = [
            { reel: this.reels[1], delayAfterStop: 200,  delay: 1000, suspense: false, shine: this.shine_gm_reel1, symbolId: [11, 10 + this.multArray[1], 11]},
            { reel: this.reels[2], delayAfterStop: 200, delay: 1000, suspense: false, shine: this.shine_gm_reel2, symbolId: [11, 10 + this.multArray[2], 11]},
            { reel: this.reels[0],  delayAfterStop: 1700, delay: 2000, suspense: true, shine: this.shine_gm_reel0, symbolId: [this.idPlus(10 + this.multArray[0]), 10 + this.multArray[0], this.idMinus(10 + this.multArray[0])]}
        ];

        for (let {reel, delay, suspense, shine, symbolId, delayAfterStop} of reelConfigs) {
            if (suspense) {
                reel.subFakeList =  this.fakeListMap();
                reel.playSpeedAnimation(1500, 1);
                this.dampingSound();
            }

            await game.utils.delay(delay);

            if (suspense) {
                const randomValue: boolean = Math.random() <= 0.5;
                delayAfterStop = (randomValue ? 3100 : 2300) + this.additionalTime ;
                reel.randomStopFinalReel(randomValue);
            }

            reel.stopRotate(symbolId);
            await this.oncePromise('ReelsetComponent.Reel.REEL_STOPPED', reel.eventEmitter);
            // await game.utils.delay(delayAfterStop);

            if (suspense) game.emit('BonusReelsetComponent.REEL_BONUS_ANTICIPATION_FINISH');

            shine.visible = false;
        }

        this.reels[0].setDefaultOption();
        this.additionalTime = 0;
    }

    oncePromise(name: string, eventEmmiter): Promise<void> {
        return new Promise(resolve => {
            eventEmmiter.once(name, resolve);
        })
    }

    protected async dampingSound(){
        await game.utils.delay(1000);
        game.emit('BonusGameComponent.START_INTRIGUE');
    }

    addZeroForAlphaAnimation(){
        if (this.multArray[0] === 0) {
            this.arrayZeroAlpha.push(this.reels[0]);
        }
        if (this.multArray[1] === 0 && this.multArray[0] === 0) {
            this.arrayZeroAlpha.push(this.reels[1]);
        }
        if (this.multArray[2] === 0 && this.multArray[1] === 0 && this.multArray[0] === 0) {
            this.arrayZeroAlpha.push(this.reels[2]);
        }

    }

    async startWinScaleAnimations(){
       this.addZeroForAlphaAnimation();

        game.emit('BonusGameComponent.MULTIPLIER_WIN');

        game.utils.GameUtils.playScaleYoyoAnimation(this.popup, {scaleFrom: this.popup.scale.x, scaleTo: this.popup.scale.x + 0.06, time: 250, loop: -1});

        this.arrayZeroAlpha.forEach(item => game.utils.GameUtils.playAlphaAnimation(item.view, {from: 1, to: 0, time: 300, timeWait: 0}))
    }

    async initHidePopup(){
        for (const item of this.reels) {
            game.utils.removeCall(item.view._tween);
        }

        game.utils.removeCall(this.popup._tween);

        this.spine_gm.playAnimation('idle', true);

        game.utils.GameUtils.playAlphaAnimation(this.popup2, {from: 1, to: 0, time: 300, timeWait: 0});
        game.utils.GameUtils.playAlphaAnimation(this.backgroundBonus, {from: 1, to: 0, time: 300, timeWait: 0});
    }

    protected setTotalWin(value?: number | undefined): number{
        //@ts-ignore
        this.store.gameData.winAmount = typeof value === "number" ? value : game.store.gameData.gamble.winAmount;
        this.store.gameData.visualWinAmount = this.store.gameData.winAmount;
        game.emit('UI.UPDATED');

        //@ts-ignore
        return game.store.gameData.bonusGame.win;
    }

    async showOutroPopup(){
        game.utils.GameUtils.playScaleYoyoAnimation(this.clickAnywhereOutroPopup, {scaleFrom: 1, scaleTo: 1.1, time: 1000, loop: -1});
        await game.utils.GameUtils.playAlphaAnimation(this.popupOutroContainer, {from: 0, to: 1, time: 300, timeWait: 0});

        this.popup2.visible = false;
        this.setTotalWin(game.store.gameData.bonusGame.win);


        game.emit('BonusGameComponent.COUNTER_START');

        let isFinishedCounter: boolean = false;

        const idSetTimeoutEventCounterStop = setTimeout(() => {
            game.emit('BonusGameComponent.COUNTER_STOP');
            isFinishedCounter = true;
            game.store.balance += game.store.gameData.bonusGame.win;
            game.emit('UI.UPDATED');
        },3000);

        await Promise.race([
            this.waitClick(),
            game.onceDataPromise('Button.clicked', {
                component: 'bonusReelset',
                name: 'bonus.wrapper_container.wrapper_outro_popup.btn'
            }),
            game.utils.GameUtils.playCounterAnimation(this.winOutroText, {from: 0, to: game.store.gameData.bonusGame.win, time: 3000, timeWait: 10000}),
        ])

        game.tree.findByName('bonus.wrapper_container.wrapper_outro_popup.btn').visible = false

        clearTimeout(idSetTimeoutEventCounterStop);

        if(!isFinishedCounter) {
            game.emit('BonusGameComponent.COUNTER_STOP');
            game.store.balance += game.store.gameData.bonusGame.win;
            game.emit('UI.UPDATED');
        }

        game.utils.removeCall(this.winOutroText._tween);
        this.winOutroText.options.text = this.store.toFormatMoney(game.store.gameData.bonusGame.win);
        this.winOutroText.updateViewOptions();
    }

    async hideOutroPopup(){
        await game.utils.delay(700);
        this.winOutroText.options.text = ''
        this.winOutroText.updateViewOptions();

        this.arrayZeroAlpha.forEach(item => game.utils.GameUtils.playAlphaAnimation(item.view, {from: 0, to: 1, time: 100, timeWait: 0}))
        this.arrayZeroAlpha = []

        await game.utils.GameUtils.playAlphaAnimation(this.popupOutroContainer, {from: 1, to: 0, time: 300, timeWait: 0});
    }

    onChangeOrientation() {
        super.onChangeOrientation();

        if (game.render.isLandscapeMode) {
            game.utils.removeCall(this.popup._tween);

            this.popup.options.scale.x = 1
            this.popup.options.scale.y = 1
            this.popup.forceViewUpdate();
        }

        if (game.render.isPortraitMode) {
            game.utils.removeCall(this.popup._tween);

            this.popup.options.scale.x = 0.7
            this.popup.options.scale.y = 0.7
            this.popup.forceViewUpdate();
        }
        this.additionalTime = 800;
    }

    getFSMHandlers() {
        return {
            ...super.getFSMHandlers(),
            CHECK: {
                checkStartBonusGame: {
                    on: async () => {
                        game.emit(`BonusGameComponent.START_BONUS_GAME`);

                        this.isBonusGameStart = true;
                        game.tree.findByName('background_bonus').updateViewOptions();

                        await this.initShowPopup();
                        await this.startRotateReels();
                        await this.customStopRotateReels();

                        this.spine_gm.playAnimation('win', true);

                        this.startWinScaleAnimations();

                        await game.utils.delay(2000);

                        await this.initHidePopup();
                        this.onChangeOrientation();

                        this.isBonusGameStart = false;

                        game.tree.findByName('background_bonus').updateViewOptions();

                        game.emit(`BonusGameComponent.START_OUTRO_TRANSITION`);

                        await this.showOutroPopup();

                        game.emit(`BonusGameComponent.END_OUTRO_TRANSITION`);

                        await this.hideOutroPopup();
                        this.onChangeOrientation();
                    },
                    //@ts-ignore
                    check: () => game.store.gameData.bonusGame.isStarted()
                }
            }
        }
    }

    get store(): SlotGameStore {
        return <SlotGameStore>game.store;
    }
}

// @ts-ignore
Game.src.component.BonusReelsetComponent = BonusReelsetComponent;
